<template>
  <div class="bg-white px-3" style="margin: -20px; margin-top: -1rem; margin-bottom: 0!important;">
    <div class="mt-3 pt-2" style="display: flex; justify-content: center;">
      <el-card class="box-card" style="width: 100%; max-width: 1000px">
        <div slot="header" class="clearfix">
          <div style="display: flex; align-items: center;">
            <el-input type="text" v-model="form.code"
              placeholder="手动输入条形码"
              clearable size="small" style="width: 85%;"></el-input>
            <el-button icon="el-icon-full-screen" size="small" type="primary" @click="startCameraOrStop">{{ isCameraActive ? '停止' : '扫码' }}</el-button>
          </div>
        </div>
        <div class="text item">
          扫码结果：{{ form.code }}
        </div>
        <div>
          <button @click="chooseImage">选择图片</button>
          <input type="file" ref="fileInput" @change="scanImage" accept="image/*" style="display: none;">
          <div ref="cameraPreview" id="camera-preview" style="width: 100%; height: 400px;"></div>
        </div>
      </el-card>
    </div>
  </div>
</template>

<script>
import Quagga from 'quagga';

export default {
  data() {
    return {
      form: {
        code: '',
      },
      isCameraActive: false,
    };
  },
  methods: {
    startCameraOrStop() {
      if (this.isCameraActive) {
        Quagga.stop();
        this.isCameraActive = false;
      } else {
        this.startCamera();
      }
    },
    startCamera() {
      Quagga.init({
        inputStream: {
          type: "LiveStream",
          target: this.$refs.cameraPreview,
          constraints: {
            width: 640,
            height: 480,
            facingMode: "environment"
          }
        },
        decoder: {
          readers: ["code_128_reader"]
        },
        locate: true,
        debug: {
          drawBoundingBox: true,
          showFrequency: true,
          drawScanline: true,
          showPattern: true
        }
      }, (err) => {
        if (err) {
          console.error(err);
          return;
        }
        Quagga.start();
        this.isCameraActive = true;
      });

      Quagga.onDetected(this.onDetected);
    },
    chooseImage() {
      this.$refs.fileInput.click();
    },
    scanImage(event) {
      const file = event.target.files[0];
      if (file) {
        const reader = new FileReader();
        reader.onload = (e) => {
          this.scanBarcode(e.target.result);
        };
        reader.readAsDataURL(file);
      }
    },
    scanBarcode(src) {
      Quagga.decodeSingle({
        src,
        numOfWorkers: 0,
        inputStream: {
          size: 800,
          singleChannel: false
        },
        decoder: {
          readers: ["code_128_reader"]
        },
        locate: true,
        debug: {
          drawBoundingBox: true,
          showFrequency: true,
          drawScanline: true,
          showPattern: true
        }
      }, (result) => {
        if (result && result.codeResult) {
          this.form.code = result.codeResult.code;
        } else {
          this.form.code = '未检测到条形码';
        }
      });
    },
    onDetected(result) {
      if (result && result.codeResult) {
        this.form.code = result.codeResult.code;
        Quagga.stop();
        this.isCameraActive = false;
      }
    }
  }
}
</script>

<style>
</style>
